import { render, staticRenderFns } from "./GlobalVariablesList.vue?vue&type=template&id=fff8a342&scoped=true"
import script from "./GlobalVariablesList.vue?vue&type=script&lang=js"
export * from "./GlobalVariablesList.vue?vue&type=script&lang=js"
import style0 from "./GlobalVariablesList.vue?vue&type=style&index=0&id=fff8a342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff8a342",
  null
  
)

export default component.exports